module.exports = {"511902001":"东城街道","511902002":"西城街道","511902003":"回风街道","511902004":"江北街道","511902005":"宕梁街道","511902006":"玉堂街道","511902100":"大茅坪镇","511902101":"清江镇","511902103":"水宁寺镇","511902104":"化成镇","511902105":"曾口镇","511902106":"梁永镇","511902107":"三江镇","511902108":"鼎山镇","511902109":"大罗镇","511902122":"枣林镇","511902123":"平梁镇","511902124":"光辉镇","511902125":"寺岭镇","511902126":"梓桐庙镇","511902127":"凤溪镇","511902202":"花溪乡","511902203":"大和乡","511902204":"白庙乡","511902205":"关渡乡","511902206":"凌云乡","511902209":"金碑乡","511902210":"羊凤乡","511902212":"龙背乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511902.json
// module id = 2388
// module chunks = 0